import React from 'react';
import { cn } from '../../lib/utils';
import { CARD_SURFACE_CLASS } from '../ui/Card';

export function NavigablePanel({ navId, onNavigate, children, className }) {
  function handleActivate() {
    onNavigate(navId);
  }

  function handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleActivate();
    }
  }

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleActivate}
      onKeyDown={handleKeyDown}
      className={cn(
        CARD_SURFACE_CLASS,
        'h-full min-h-[240px] min-w-0 cursor-pointer overflow-hidden transition-shadow hover:shadow-[0_8px_24px_rgba(15,23,42,0.12)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#201C35]',
        className
      )}
      aria-label="Open detailed view"
    >
      <div className="h-full [&>*]:h-full [&>*]:rounded-none [&>*]:border-0 [&>*]:shadow-none">{children}</div>
    </div>
  );
}
